import React from "react";
import cx from "clsx";
import { CtaImage } from "./CtaImage";
export var CtaPhone = function (_a) {
    var className = _a.className, label = _a.label, value = _a.value, image = _a.image;
    return (React.createElement("a", { href: "tel:" + value, className: cx("flex justify-between", className) },
        image && React.createElement(CtaImage, { image: image, className: "md:mr-3" }),
        React.createElement("span", { className: "hidden md:inline-block" }, label)));
};
//# sourceMappingURL=CtaPhone.js.map